import { localize } from "client_legacy/ndaw/culture";
import { Action, ActionGroup, ActionKind } from "client_legacy/ndaw/actions";
import { FolderCounters } from "client/Api/Email/email";

export type EmailListActionContext = {
	counters: FolderCounters;
	smtpAddress: string;
	folderId: string;
};

export type EmailListAction = Action<EmailListActionContext>;

export type EmailListActionHandlers = {
	refreshList(): void;
	markAllAsRead(smtpAddress: string, folderId: string): void;
	markAllAsUnRead(smtpAddress: string, folderId: string): void;
};

type Options = {
	handlers: EmailListActionHandlers;
};

const refreshGroup: ActionGroup = {
	kind: "regular",
	name: "refresh-group",
	title: localize("_Refresh")
};

class EmailListActions {
	private readonly _refreshList: EmailListAction;
	private readonly _markAllAsRead: EmailListAction;
	private readonly _markAllAsUnread: EmailListAction;

	constructor(options: Options) {
		const { handlers } = options;

		this._refreshList = {
			kind: ActionKind.Regular,
			name: "refresh",
			title: localize("_Refresh"),
			icon: "arrow-rotate-right",
			canExecute: _ => true,
			execute: () => handlers.refreshList(),
			group: refreshGroup
		};

		this._markAllAsRead = {
			kind: ActionKind.Regular,
			name: "markAllAsRead",
			title: localize("_MarkAllAsRead"),
			canExecute: () => true,
			execute:
				(c: EmailListActionContext): void => {
					handlers.markAllAsRead(
						c.smtpAddress,
						c.folderId
					);
				},
			icon: "envelope-open"
		};

		this._markAllAsUnread = {
			kind: ActionKind.Regular,
			name: "markAllAsUnread",
			title: localize("_MarkAllAsUnread"),
			canExecute:
				(c: EmailListActionContext): boolean => {
					const {
						total,
						unread
					} = c.counters;

					return total > 0
						&& unread < total;
				},
			execute:
				(c: EmailListActionContext): void => {
					handlers.markAllAsUnRead(
						c.smtpAddress,
						c.folderId
					);
				},
			icon: "envelope"
		};
	}

	public getAllActions(): EmailListAction[] {
		const actions: EmailListAction[] = [
			this._refreshList,
			this._markAllAsRead,
			this._markAllAsUnread
		];

		return actions;
	}
}

export {
	EmailListActions
};
